export const isStoreScreenshotCapture = process.env.REACT_APP_SCREENSHOT_MODE === "true";

export const storeScreenshotUser = Object.freeze({
  uid: "store-screenshot-passenger",
  displayName: "Passageiro Zuno",
  email: "",
  phoneNumber: "",
  photoURL: "",
  providerData: [],
});

export async function initializeStoreScreenshotSession() {
  if (!isStoreScreenshotCapture) return { enabled: false };

  localStorage.setItem("userType", "passenger");
  localStorage.setItem("usuarioLogado", "Passageiro Zuno");
  localStorage.setItem("userEmail", "");
  localStorage.setItem("usuarioFoto", "");
  localStorage.setItem("zunoLocationPrimer", "skipped");
  localStorage.setItem("zunoNotificationPrimer", "skipped");
  localStorage.setItem("locationPermission", "granted");
  localStorage.setItem(`zunoPassengerSeen:${storeScreenshotUser.uid}`, "1");

  return { enabled: true, uid: storeScreenshotUser.uid };
}

export function endStoreScreenshotSession() {
  if (isStoreScreenshotCapture) window.dispatchEvent(new Event("zuno:store-screenshot-sign-out"));
}
